var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"page-header navbar navbar-fixed-top sticky"},[_c('div',{staticClass:"page-header-content"})])])
}]

export { render, staticRenderFns }